import React from 'react';

const DevelopmentItemLoading = () => (
  <div className="development-item col-md-4 col-sm-6 col-lg-4">
    <div className="shadow">
      <div className="img-responsive" />
      <div className="container-fluid development-container">
        <div className="loading" style={{ height: 22, width: 200, marginTop: 20 }} />
        <div className="loading" style={{ height: 15, width: 120, marginTop: 10 }} />
        <table className="table table-icon compact">
          <tbody>
            <tr>
              <td>
                <span className="icon-2x icon-bed text-primary" aria-hidden="true" />
              </td>
              <td>
                <div className="loading" style={{ height: 15, width: 50 }} />
              </td>
            </tr>
            <tr>
              <td>
                <span className="icon-2x icon-gbp text-primary" aria-hidden="true" />
              </td>
              <td>
                <div className="loading" style={{ height: 15, width: 100 }} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="dev-button">
        <div>
          <div className="loading" style={{ height: 20, width: 150, margin: '0 auto' }} />
        </div>
      </div>
    </div>
  </div>
);

export default DevelopmentItemLoading;
